import React from 'react';
import styled from 'styled-components';
import Layout from '../components/Layout';
import { Helmet } from 'react-helmet';
// 引入Banner图和About us配图
import banner from '../images/banner.jpg';
import aboutImg from '../images/ups-shot.jpg'; // 用你现有的ups-shot.jpg作为About us配图

// 页面容器
const AboutContainer = styled.div`
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem;
  box-sizing: border-box;

  @media (max-width: 768px) {
    padding: 1rem;
  }
`;

// Banner图容器
const BannerSection = styled.section`
  width: 100%;
  background-color: #0099ff;
  padding: 0.5rem 0;
  display: flex;
  justify-content: center;
  box-sizing: border-box;
  margin-bottom: 0.5rem;
`;

const BannerImage = styled.div`
  width: 80%;
  height: 400px;
  background-image: url(${banner});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;

  @media (max-width: 768px) {
    width: 95%;
    height: 200px;
  }
`;

// About us内容区域
const ContentSection = styled.section`
  width: 100%;
  box-sizing: border-box;
`;

const AboutTitle = styled.h2`
  font-size: 1.2rem;
  color: #333;
  border-bottom: 1px solid #eee;
  padding-bottom: 0.5rem;
  margin-bottom: 1rem;
`;

const ContentWrapper = styled.div`
  display: flex;
  gap: 1.5rem;
  align-items: flex-start;
  margin-bottom: 1.5rem;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

const AboutImage = styled.div`
  flex: 0 0 300px;
  height: 200px;
  background-image: url(${aboutImg});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;

  @media (max-width: 768px) {
    flex: 0 0 100%;
    width: 100%;
  }
`;

const AboutText = styled.div`
  flex: 1;
  color: #333;
  line-height: 1.6;
  font-size: 1rem;

  p {
    margin: 0 0 1rem 0;
  }
`;

const AboutPage = () => {
  return (
    <Layout>
      <Helmet>
        <title>About us - Wisdom</title>
        <meta name="description" content="About Wisdom, a professional OEM/ODM supplier of home appliances." />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      </Helmet>
      {/* Banner区域 */}
      <BannerSection>
        <BannerImage />
      </BannerSection>
      {/* About us内容区域 */}
      <AboutContainer>
        <ContentSection>
          <AboutTitle>About us</AboutTitle>
          <ContentWrapper>
            <AboutImage />
            <AboutText>
              <p>
                Since 2006， we are driven by technology and customer's need. We supply customer at good quality products and competitive price, with qualified service. Our mission is supply quaified products and satisfied service. To improve quality control, we have passed BV ISO9001:2015/BSCI/CE/RoHS/CB ect , Quality management system and social responsibility system.
              </p>
            </AboutText>
          </ContentWrapper>
          <AboutText>
            <p>
              We have built-up production bases in Shenzhen City of Guangdong province, Hezhou City of Guangxi province, Ningbo City of Zhejiang province, in order to give clients, good quality products and fast delivery. Also at Hochiminh city of Vietnam, we have production base to match clients' demand around the world.
            </p>
          </AboutText>
        </ContentSection>
      </AboutContainer>
    </Layout>
  );
};

export default AboutPage;